// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"7f4016ef","787":"61f74e33","831":"67ac44ee"}[chunkId] + ".chunk.js";
};